import { render, staticRenderFns } from "./OVActionsIndex.vue?vue&type=template&id=36ca32fa&scoped=true&lang=pug"
import script from "./OVActionsIndex.vue?vue&type=script&lang=js"
export * from "./OVActionsIndex.vue?vue&type=script&lang=js"
import style0 from "./OVActionsIndex.vue?vue&type=style&index=0&id=36ca32fa&prod&lang=scss&scoped=true"
import style1 from "./OVActionsIndex.vue?vue&type=style&index=1&id=36ca32fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca32fa",
  null
  
)

export default component.exports